import React from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';
export interface TablePaginationProps {
  page: number;
  pageSize: number;
  total: number;
  pageSizes?: number[];
  onPageChange: (page: number) => void;
  onPageSizeChange?: (pageSize: number) => void;
}
export function TablePagination({
  page,
  pageSize,
  total,
  pageSizes = [25, 50, 100],
  onPageChange,
  onPageSizeChange
}: TablePaginationProps) {
  const totalPages = Math.max(1, Math.ceil(total / pageSize));
  const start = page * pageSize + 1;
  const end = Math.min((page + 1) * pageSize, total);
  return <div className="px-4 py-3 border-t border-gray-100 flex flex-col sm:flex-row sm:items-center justify-between bg-gray-50 gap-3" data-id="element-7696">
      <div className="flex items-center gap-4 text-xs text-gray-500" data-id="element-7697">
        {total > 0 ? <span data-id="element-7698">
            Resultaat <span className="font-medium text-gray-900" data-id="element-7699">{start}</span>{' '}
            tot <span className="font-medium text-gray-900" data-id="element-7700">{end}</span> van{' '}
            <span className="font-medium text-gray-900" data-id="element-7701">{total}</span>
          </span> : <span data-id="element-7702">Geen resultaten</span>}

        {onPageSizeChange && total > 0 && <div className="flex items-center gap-2 border-l border-gray-200 pl-4" data-id="element-7703">
            <span data-id="element-7704">Rijen per pagina:</span>
            <select value={pageSize} onChange={e => onPageSizeChange(Number(e.target.value))} className="bg-transparent font-medium text-gray-900 focus:outline-none cursor-pointer" data-id="element-7705">
              {pageSizes.map(size => <option key={size} value={size} data-id="element-7706">
                  {size}
                </option>)}
            </select>
          </div>}
      </div>

      <div className="flex items-center gap-2" data-id="element-7707">
        <span className="text-xs text-gray-500 mr-2" data-id="element-7708">
          Pagina {page + 1} van {totalPages}
        </span>
        <div className="flex gap-1" data-id="element-7709">
          <button onClick={() => onPageChange(Math.max(0, page - 1))} disabled={page === 0} className="p-1.5 text-gray-500 bg-white border border-gray-200 rounded-md hover:bg-gray-50 hover:text-gray-900 disabled:opacity-50 disabled:cursor-not-allowed transition-colors" aria-label="Vorige pagina" data-id="element-7710">
            <ChevronLeft className="w-4 h-4" data-id="element-7711" />
          </button>
          <button onClick={() => onPageChange(Math.min(totalPages - 1, page + 1))} disabled={page >= totalPages - 1 || total === 0} className="p-1.5 text-gray-500 bg-white border border-gray-200 rounded-md hover:bg-gray-50 hover:text-gray-900 disabled:opacity-50 disabled:cursor-not-allowed transition-colors" aria-label="Volgende pagina" data-id="element-7712">
            <ChevronRight className="w-4 h-4" data-id="element-7713" />
          </button>
        </div>
      </div>
    </div>;
}